// config.js

const environment = process.env.REACT_APP_ENVIRONMENT || 'local';

const API_BASE_URL =
  environment === 'local' ? 'http://localhost:8000' : 'https://intence.ai';

const config = {
  API_BASE_URL,
};

export default config;
